import { post } from "@utils/fetch";

type ValidateDiscoveryTokenInput = {
  token: string;
  stytchTokenType: "discovery_oauth" | "impersonation";
};

type ValidateDiscoveryTokenResponse = {
  data: {
    intermediateSessionToken: string;
    discoveredOrganizations: {
      organizationId: string;
      organizationName: string;
    }[];
  };
};

export const validateDiscoveryToken = async (
  input: ValidateDiscoveryTokenInput,
): Promise<ValidateDiscoveryTokenResponse> => {
  const { data } = await post(
    "/api/public/v1/auth/validate-discovery-token/",
    input,
  );

  return data;
};
